import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ChooseLocationPage from './ChooseLocationPage/ChooseLocationPage';
import PrepareHomePage from './PrepareHomePage/PrepareHomePage';

const PrepareFeature = () => (
  <Switch>
    <Route path="/maps/prepare" exact>
      <Redirect to="/maps/prepare/checklist" />
    </Route>
    <Route path="/maps/prepare/:pagename" exact>
      <PrepareHomePage />
    </Route>
    <Route path="/maps/prepare/checklist/choose-location" exact>
      <ChooseLocationPage />
    </Route>
  </Switch>
);

export default PrepareFeature;
